import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ChevronRight, Shield, Leaf } from 'lucide-react';
import { FAQAccordion } from '../../components/FAQAccordion';
import { CTAStrip } from '../../components/CTAStrip';
import { InlineCostCalculator } from '../../components/InlineCostCalculator';
const faqs = [{
  question: 'What garden waste do you collect?',
  answer: 'We collect all green waste including grass cuttings, branches, soil, rubble, paving slabs, garden furniture, sheds, and general garden clearance waste.'
}, {
  question: 'Do you collect soil and rubble?',
  answer: 'Yes, we collect soil, rubble, and heavy garden waste. These are priced separately due to weight — contact us for a quote.'
}, {
  question: 'How quickly can you collect garden waste?',
  answer: 'We offer same-day and next-day collections in most London areas. Contact us to check availability.'
}, {
  question: 'Is garden waste recycled?',
  answer: 'Yes. All green waste is composted or processed at licensed facilities. We aim for zero landfill on garden waste.'
}, {
  question: 'Do you clear whole gardens?',
  answer: 'Absolutely. We offer full garden clearance services including overgrown vegetation, old sheds, and all garden waste.'
}];
export function GardenWastePage() {
  return <div className="pt-16 lg:pt-20" data-id="element-855">
      <section className="relative h-72 md:h-96 overflow-hidden" data-id="element-856">
        <img src="https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=1600&auto=format&fit=crop" alt="Garden waste" className="w-full h-full object-cover" data-id="element-857" />
        <div className="absolute inset-0 hero-overlay" data-id="element-858" />
        <div className="absolute inset-0 flex items-center" data-id="element-859">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-860">
            <nav className="flex items-center gap-2 text-green-200 text-sm mb-4" data-id="element-861">
              <Link to="/" className="hover:text-white" data-id="element-862">
                Home
              </Link>
              <ChevronRight className="w-4 h-4" data-id="element-863" />
              <Link to="/services" className="hover:text-white" data-id="element-864">
                Services
              </Link>
              <ChevronRight className="w-4 h-4" data-id="element-865" />
              <span className="text-white" data-id="element-866">Garden Waste</span>
            </nav>
            <h1 className="text-3xl md:text-5xl font-extrabold text-white" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-867">
              Garden Waste Removal London
            </h1>
            <p className="text-green-100 mt-3 text-lg" data-id="element-868">
              All green waste collected and composted. From £80.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-white" data-id="element-869">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-870">
          <div data-id="element-871">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-872">
              What's Included
            </h2>
            <ul className="space-y-3" data-id="element-873">
              {['Grass cuttings & hedge trimmings', 'Branches & tree prunings', 'Soil & turf removal', 'Garden furniture & sheds', 'Paving slabs & rubble', 'Full garden clearances', 'Composting & eco-disposal', 'Same-day options available'].map(item => <li key={item} className="flex items-center gap-3" data-id="element-874">
                  <CheckCircle className="w-5 h-5 flex-shrink-0" style={{
                color: '#1B8F4B'
              }} data-id="element-875" />
                  <span className="text-gray-700" data-id="element-876">{item}</span>
                </li>)}
            </ul>
          </div>
          <div data-id="element-877">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-878">
              Ideal For
            </h2>
            <div className="space-y-4" data-id="element-879">
              {[{
              title: 'Homeowners',
              desc: 'After a garden tidy-up or seasonal clearance.'
            }, {
              title: 'Landlords',
              desc: 'Clearing overgrown gardens between tenancies.'
            }, {
              title: 'Garden Contractors',
              desc: 'Regular green waste removal for landscapers.'
            }, {
              title: 'Estate Agents',
              desc: 'Preparing gardens for property viewings.'
            }].map(({
              title,
              desc
            }) => <div key={title} className="p-4 rounded-xl border border-gray-100 hover:border-[#1B8F4B] transition-colors" data-id="element-880">
                  <h3 className="font-bold text-gray-900 mb-1 text-sm" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-881">
                    {title}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-882">{desc}</p>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-white" data-id="element-883">
        <div className="max-w-3xl mx-auto text-center" data-id="element-884">
          <div className="rounded-2xl border-2 border-[#1B8F4B] p-8 mb-6" data-id="element-885">
            <p className="text-4xl font-extrabold mb-2" style={{
            color: '#1B8F4B',
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-886">
              From £80
            </p>
            <p className="text-gray-500 mb-6" data-id="element-887">
              Guide price for a small garden clearance. Heavy materials priced
              separately.
            </p>
            <Link to="/contact" className="inline-block px-8 py-4 rounded-xl font-bold text-white transition-colors hover:opacity-90" style={{
            backgroundColor: '#1B8F4B',
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-888">
              Request a Quote
            </Link>
          </div>
          <div className="flex justify-center gap-6" data-id="element-889">
            <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-890">
              <Shield className="w-4 h-4" style={{
              color: '#1B8F4B'
            }} data-id="element-891" />{' '}
              Licensed & Fully Insured
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-892">
              <Leaf className="w-4 h-4" style={{
              color: '#1B8F4B'
            }} data-id="element-893" />{' '}
              Eco-Friendly Disposal
            </div>
          </div>
        </div>
      </section>

      <InlineCostCalculator defaultService="garden-waste" serviceName="Garden Waste" data-id="element-894" />

      <section className="py-16 px-4 bg-white" data-id="element-895">
        <div className="max-w-3xl mx-auto" data-id="element-896">
          <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-897">
            FAQs
          </h2>
          <FAQAccordion items={faqs} data-id="element-898" />
        </div>
      </section>
      <CTAStrip heading="Ready to Clear Your Garden?" subheading="Get a free quote today. We reply within 30 minutes." data-id="element-899" />
    </div>;
}